/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OrelySignatureService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Handle Orely callback
     * 
     * @param flowId flowId
     * @param signatureId signatureId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public handleCallbackMock(flowId: string, signatureId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public handleCallbackMock(flowId: string, signatureId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public handleCallbackMock(flowId: string, signatureId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public handleCallbackMock(flowId: string, signatureId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (flowId === null || flowId === undefined) {
            throw new Error('Required parameter flowId was null or undefined when calling handleCallbackMock.');
        }

        if (signatureId === null || signatureId === undefined) {
            throw new Error('Required parameter signatureId was null or undefined when calling handleCallbackMock.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<string>(`${this.basePath}/orely/sign/mock/${encodeURIComponent(String(signatureId))}/${encodeURIComponent(String(flowId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Handle Orely callback
     * 
     * @param authenticated 
     * @param authorities0Authority 
     * @param credentials 
     * @param details 
     * @param principal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public handleCallbackResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public handleCallbackResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public handleCallbackResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public handleCallbackResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authenticated !== undefined && authenticated !== null) {
            queryParameters = queryParameters.set('authenticated', <any>authenticated);
        }
        if (authorities0Authority !== undefined && authorities0Authority !== null) {
            queryParameters = queryParameters.set('authorities[0].authority', <any>authorities0Authority);
        }
        if (credentials !== undefined && credentials !== null) {
            queryParameters = queryParameters.set('credentials', <any>credentials);
        }
        if (details !== undefined && details !== null) {
            queryParameters = queryParameters.set('details', <any>details);
        }
        if (principal !== undefined && principal !== null) {
            queryParameters = queryParameters.set('principal', <any>principal);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orely/sign/callback`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Handle Orely callback
     * 
     * @param authenticated 
     * @param authorities0Authority 
     * @param credentials 
     * @param details 
     * @param principal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public handleCallbackResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public handleCallbackResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public handleCallbackResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public handleCallbackResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authenticated !== undefined && authenticated !== null) {
            queryParameters = queryParameters.set('authenticated', <any>authenticated);
        }
        if (authorities0Authority !== undefined && authorities0Authority !== null) {
            queryParameters = queryParameters.set('authorities[0].authority', <any>authorities0Authority);
        }
        if (credentials !== undefined && credentials !== null) {
            queryParameters = queryParameters.set('credentials', <any>credentials);
        }
        if (details !== undefined && details !== null) {
            queryParameters = queryParameters.set('details', <any>details);
        }
        if (principal !== undefined && principal !== null) {
            queryParameters = queryParameters.set('principal', <any>principal);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<string>(`${this.basePath}/orely/sign/callback`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Handle Orely signature
     * 
     * @param signerId signerId
     * @param transactionId transactionId
     * @param authenticated 
     * @param authorities0Authority 
     * @param credentials 
     * @param details 
     * @param principal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public handleOrelySignature(signerId: string, transactionId: number, authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public handleOrelySignature(signerId: string, transactionId: number, authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public handleOrelySignature(signerId: string, transactionId: number, authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public handleOrelySignature(signerId: string, transactionId: number, authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (signerId === null || signerId === undefined) {
            throw new Error('Required parameter signerId was null or undefined when calling handleOrelySignature.');
        }

        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling handleOrelySignature.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authenticated !== undefined && authenticated !== null) {
            queryParameters = queryParameters.set('authenticated', <any>authenticated);
        }
        if (authorities0Authority !== undefined && authorities0Authority !== null) {
            queryParameters = queryParameters.set('authorities[0].authority', <any>authorities0Authority);
        }
        if (credentials !== undefined && credentials !== null) {
            queryParameters = queryParameters.set('credentials', <any>credentials);
        }
        if (details !== undefined && details !== null) {
            queryParameters = queryParameters.set('details', <any>details);
        }
        if (principal !== undefined && principal !== null) {
            queryParameters = queryParameters.set('principal', <any>principal);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orely/sign/${encodeURIComponent(String(transactionId))}/${encodeURIComponent(String(signerId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resolve Orely response
     * 
     * @param authenticated 
     * @param authorities0Authority 
     * @param credentials 
     * @param details 
     * @param principal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resolveOrelyResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resolveOrelyResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resolveOrelyResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resolveOrelyResponse(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authenticated !== undefined && authenticated !== null) {
            queryParameters = queryParameters.set('authenticated', <any>authenticated);
        }
        if (authorities0Authority !== undefined && authorities0Authority !== null) {
            queryParameters = queryParameters.set('authorities[0].authority', <any>authorities0Authority);
        }
        if (credentials !== undefined && credentials !== null) {
            queryParameters = queryParameters.set('credentials', <any>credentials);
        }
        if (details !== undefined && details !== null) {
            queryParameters = queryParameters.set('details', <any>details);
        }
        if (principal !== undefined && principal !== null) {
            queryParameters = queryParameters.set('principal', <any>principal);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orely/sign/resolve`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resolve Orely response
     * 
     * @param authenticated 
     * @param authorities0Authority 
     * @param credentials 
     * @param details 
     * @param principal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resolveOrelyResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resolveOrelyResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resolveOrelyResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resolveOrelyResponse1(authenticated?: boolean, authorities0Authority?: string, credentials?: string, details?: string, principal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authenticated !== undefined && authenticated !== null) {
            queryParameters = queryParameters.set('authenticated', <any>authenticated);
        }
        if (authorities0Authority !== undefined && authorities0Authority !== null) {
            queryParameters = queryParameters.set('authorities[0].authority', <any>authorities0Authority);
        }
        if (credentials !== undefined && credentials !== null) {
            queryParameters = queryParameters.set('credentials', <any>credentials);
        }
        if (details !== undefined && details !== null) {
            queryParameters = queryParameters.set('details', <any>details);
        }
        if (principal !== undefined && principal !== null) {
            queryParameters = queryParameters.set('principal', <any>principal);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<string>(`${this.basePath}/orely/sign/resolve`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
